export const environment = {
    production: true,
    CONTEXT: '/oebak-teilnehmer', // Context der App auf dem WAS, ist in package.json scripts build-prod konfiguriert
    API_URL: 'api', // ohne Context sondern relativ zu <base href="/gaverw/">, wie es in der Angular App als angegeben ist
};
